import {
	useLocation,
	useNavigate
} from "react-router-dom";
import {
	Button,
	PageTemplate,
	Stack
} from "../../components"
import { useRequest } from "../../http";
import { useTranslation } from "../../language"
import {
	useRef,
	useCallback,
	useEffect,
	useState
} from 'react';
import { IRegisterState, RegisterType } from "../../models";

export const ReceptionPage = () => {
	const location = useLocation();
	const state = location.state as IRegisterState;
	const translate = useTranslation();
	const navigate = useNavigate();
	const { execute: executeReception } = useRequest<any>("SubmitAnonymousToReceptionQueue");
	const { execute: executePartner } = useRequest<any>("SubmitAnonymousToPartnersQueue");
	const { execute: executeLab } = useRequest<any>("SubmitAnonymousToLabQueue");
	const { execute: executeVaccine } = useRequest<any>("SubmitAnonymousToVaccineQueue");
	const inactiveTimeoutSeconds = 15;
	const timerRef = useRef<any>();
	const [disabled, setDisabled] = useState(false);

	const startBackTimeout = useCallback(() => {
		const timer = () => setTimeout(() => {
			navigate("/");
		}, inactiveTimeoutSeconds * 1000);

		timerRef.current = timer();
	}, [navigate]); // This is stupid but the linter is boss.
	// The early return in the useEffect below fixes it (so that loading and startTimeout is not ran multiple times)
	// If navigate is removed from the useCallback dependency array, 
	// or startBackTimeout is removed from the useEffect dependency array, 
	// it works without the first if in the useEffect. Pls refactor me :(

	useEffect(() => {
		if (timerRef.current) {
			// Already loading the stuff or navigating away - do not start new shit now pls
			return;
		}

		startBackTimeout();
		return () => {
			if (timerRef.current) {
				clearTimeout(timerRef.current);
			}
		};
	}, [executeReception, startBackTimeout]);

	const getQueueNumber = async () => {
		setDisabled(true);
		if (timerRef.current) {
			clearTimeout(timerRef.current);
		}

		// send nothing
		let data: any = null;

		switch (state.type) {
			case RegisterType.Reception:
				data = await executeReception({});
				break;
			case RegisterType.Partners:
				data = await executePartner({});
				break;
			case RegisterType.Lab:
				data = await executeLab({});
				break;
			case RegisterType.Vaccine:
				data = await executeVaccine({});
				break;
		}

		try {
			(window as any).printer.sendToPrinter({ numberInQueue: data.numberInQueue });
		} catch (e) {
			console.error('ignoring', e);
		}

		setTimeout(() => {
			navigate("/queueNumber/" + data.numberInQueue);
		}, 200);
	};

	const getHeader = () => {
		if (!state?.type) {
			return <></>
		}
		switch (state.type) {
			case RegisterType.Reception:
				return <h2 style={{ textAlign: "center" }}>{translate("Reception.Header")}</h2>
			case RegisterType.Partners:
				return <h2 style={{ textAlign: "center" }}>{translate("Partners.Header")}</h2>
		}
	}

	return (
		<PageTemplate>
			<Stack horizontal horizontalAlign="center">
				<Stack>
					{getHeader()}
					<Stack horizontal horizontalAlign="space-around">
						<Button disabled={disabled} text={translate("Reception.Button")} onClick={getQueueNumber}></Button>
					</Stack>
				</Stack>
			</Stack>
		</PageTemplate>
	)
}